import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// eslint-disable-next-line
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        /* primary: '#0076CF',
        secondary: '#002A5C', */
        primary: '#4A89DC',
        secondary: '#ED5565',
        third: '#474d5d',
        fourth: '#808285',
        fifth: '#e4e9ff',
        sixth: '#1e2934',
        accent: '#FFCE54',
        error: '#eb4d4b',
        warning: '#F6BB42',
        info: '#7ed6df',
        success: '#8CC152',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
